// extracted by mini-css-extract-plugin
module.exports = {"topicTitleSmall":"topicTitleSmall-1TSSAOHr","title_logo":"title_logo-3OJwXwDI","title":"title-1HQ4N7rj"};